// extracted by mini-css-extract-plugin
export default {"header":"fire-dispatch-status-form_header__dVkeL"};